import { HistoryLocation } from 'ia-react-core/~/interfaces/HistoryLocation';
import noop from 'lodash/noop';

interface AnalyticsManagerOptions {
  pageView?: boolean | (() => void);
  filter?: (data: object) => boolean;
}

export type PageViewOptions<PageValues extends Object = {}> = {
  location?: HistoryLocation;
  pageValues: PageValues;
};

export type TrackOptions<Values extends Object = {}, PageValues extends Object = {}> = {
  event?: MouseEvent;
  id?: string;
  scope?: string;
  values?: Values;
  pageValues?: PageValues;
};

class AnalyticsManager<Values extends Object = {}, PageValues extends Object = {}> {
  constructor({ pageView, filter }: AnalyticsManagerOptions = {}) {
    if (pageView === false) {
      this.pageView = noop;
    }

    // Add filtering
    if (filter) {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const { track } = this;
      this.track = (data) => {
        if (filter(data)) {
          track(data);
        }
      };
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  track(options: TrackOptions<Values, PageValues>) { /* to implement */ }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pageView(options: PageViewOptions<PageValues>) { /* to implement */ }
}

export default AnalyticsManager;
